import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function usePostEntry({ step = 'start', token = '' }) {
  const mutation = useMutation({
    mutationKey: ['register', step],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/entry/${step}`), {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
